var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',_vm._g(_vm._b({class:[_vm.$style[_vm.$attrs.appearance], ( _obj = {}, _obj[_vm.$style.selected] = _vm.isSelected, _obj )]},'Button',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.$scopedSlots || _vm.$slots),function(scopedSlot,name){return _c('template',{slot:name},[_vm._t(name)],2)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }